const cleanPhone = (tel: string | null | undefined) => {
  if (!tel) return null;
  const a = tel.replace(/\D/g, "");
  return `+${a.length < 11 ? "1" : ""}${a}`;
};

export default cleanPhone;
